{
  "All learning items": "All learning items",
  "Learning": "Learning",
  "Event": "Event",
  "Events": "Events",
  "Filter by": "Filter by",
  "All types": "All",
  "All durations": "All time",
  "< 15 min": "< 15 min",
  "15-60 min": "15-60 min",
  "1-4 hrs": "1-4 hrs",
  "4-8 hrs": "4-8 hrs",
  "1-7 days": "1-7 days",
  "7-30 days": "7-30 days",
  "> 1 month": "> 1 month",
  "Sort by": "Sort by",
  "Featured": "Featured",
  "Featured_plural": "Featured",
  "Categories": "Categories",
  "Subjects": "Subjects",
  "All": "All",
  "Providers": "Partners",
  "no-filter-match": "No items found. <0>Clear filters</0>",
  "no-filter-match_events": "No events found. <0>Clear filters</0>",
  "no-learning-material": "There are no learning items.",
  "no-learning-material_collection": "There are no learning items in this Collection.",
  "no-learning-material_subject": "There are no learning items in this subject.",
  "no-learning-material_category": "There are no learning items in this category.",
  "Pending approval": "Pending approval",
  "Ongoing": "Ongoing",
  "Completed": "Completed",
  "You're done, nice work!": "You're done, nice work!",
  "No progress on learning path yet": "No progress on learning path yet",
  "external": "Campus online",
  "user-generated": "Manually added",
  "No filter": "No filter",
  "type-filter": "Type: {{type}}",
  "Title: A-Z": "Title: A-Z",
  "Title: Z-A": "Title: Z-A",
  "Date: Newest first": "Date: Newest first",
  "Date: Oldest first": "Date: Oldest first",
  "Featured first": "Featured first",
  "Event title": "Event title",
  "Filter": "Filter",
  "Filter by title": "Filter by title",
  "Choose...": "Choose...",
  "Provider": "Partner",
  "Sort": "Sort",
  "Type": "Learning type",
  "remove-course-prompt": "This action cancels your enrollment to the program \"{{name}}\" and removes all progress data.<0 />Are you sure you want to continue?",
  "All Learning": "All Learning",
  "Search": "Search",
  "Duration": "Time",
  "Filter by Space": "Filter by space",
  "Filter by Provider": "Filter by provider",
  "Filter by Type": "Filter by type",
  "Filter by Category": "Filter by category",
  "Filter by Subject": "Filter by subject",
  "Filter by Duration": "Filter by time",
  "Filter by Language": "Filter by language",
  "Filter by Attribute": "Filter by attribute",
  "More filters": "More filters",
  "Clear all filters": "Clear all filters",
  "Attributes": "Attributes",
  "Sort learning material": "Sort learning material",
  "new": "new",
  "Required": "Required",
  "expires_in_n_days_singular": "Expires in {{count}} day",
  "expires_in_n_days_plural": "Expires in {{count}} days",
  "expired": "Expired",
  "Recommended": "Recommended",
  "learning-item": "1 Learning item",
  "learning-item_other": "{{count}} Learning items",
  "Upcoming events": "Upcoming events",
  "upcoming": "Upcoming",
  "new-course": "New course",
  "cancel": "Cancel",
  "create": "Create",
  "choose-space": "Choose space",
  "space": "Space",
  "title": "Title",
  "enter-title": "Enter title",
  "settings": "Settings",
  "category": "Category",
  "total-effort": "Total time",
  "level": "Level",
  "partners": "Partners",
  "user-visibility": "Visibility",
  "save": "Save",
  "HIDDEN": "Hidden",
  "VISIBLE": "Visible",
  "FEATURED": "Featured",
  "add-your-document": "Add your document",
  "teaser": "Teaser",
  "teaser-error": "Enter description max 256 characters",
  "error-on-creation": "Unable to create course. Try again.",
  "course-created": "Course created",
  "pdf-file-upload-limit": "Only .pdf (Maximum size 200 MB)",
  "uploading": "Uploading",
  "course-deleted": "Course deleted",
  "visibility": "Visibility",
  "visibility-caption": "Choose how learners see your course",
  "hidden-caption": "Learners can't find your course in Search or Explore",
  "visible-caption": "Learners can find your course in Search or Explore",
  "featured-caption": "Bring your course to the top of the Explore page",
  "level-caption": "Show what level your course is on",
  "total-effort-caption": "Estimate time needed for learners to complete the course",
  "hours": "Hours",
  "minutes": "Minutes",
  "hours-error": "Enter number of hours",
  "minutes-error": "Enter number of minutes",
  "save-confirmation-title": "Save before leaving",
  "save-warning-caption": "Your changes will disappear if you leave without saving.",
  "dont-save": "Exit without saving",
  "save-leave": "Save & Exit",
  "fix-errors": "Missing required field",
  "fix-errors-caption": "Something is missing! Go back and check the required fields. Your changes will disappear if you leave without saving.",
  "course-remove": "Course removed from My Learning",
  "course-add": "Course saved to My Learning",
  "journey-add": "Journey saved to My Learning",
  "journey-remove": "Journey removed from My Learning",
  "list": "List",
  "remove-my-learning": "Remove from My Learning",
  "save-my-learning": "Save to My Learning",
  "close": "Close",
  "start-course": "Start",
  "total-time": "Total time",
  "status": "Status",
  "nice-work": "Nice work!",
  "success-check-in-survey": "Alright! Onwards and upwards!",
  "success-check-out-survey": "Time to turn learning into action!",
  "missing-effort-modal-title": "Set your course up to succeed",
  "missing-effort-modal-subtitle": "You can easily change under settings at anytime",
  "add-video": "Add video",
  "or": "OR",
  "Delete": "Delete",
  "Permanently remove your course": "Permanently remove your course",
  "Delete course": "Delete course",
  "You will lose all progress data": "You will lose all progress data for  <0>‘{{courseTitle}}’</0>. This cannot be undone.",
  "Are you sure you want to permanently remove this course": "Are you sure you want to <0>permanently remove</0> this course?",
  "paste-url": "PASTE URL"
}
